<template>
    <div class="rounded bg-[color:var(--disclaimer-background-color)]
        p-4 text-[color:var(--disclaimer-text-color)]"
        :style="{
            '--disclaimer-background-color': backgroundColor,
            '--disclaimer-text-color': textColor,
        }">
        <div class="text-base font-bold">
            <template v-if="disclaimer.link">
                <nuxt-link :to="disclaimer.link"
                    :aria-label="disclaimer.contentTitle"
                    :title="disclaimer.contentTitle">
                    <h4 v-if="disclaimer.contentTitle"
                        class="mb-xs text-[color:var(--disclaimer-title-color)]"
                        :style="{
                            '--disclaimer-title-color': titleColor,
                        }">
                        {{ disclaimer.contentTitle }}
                    </h4>

                    <!-- eslint-disable vue/no-v-html -->
                    <p v-html="disclaimer.content">
                    </p>
                </nuxt-link>
            </template>

            <div v-else>
                <h4 v-if="disclaimer.contentTitle"
                    class="mb-xs text-[color:var(--disclaimer-title-color)]"
                    :style="{
                        '--disclaimer-title-color': titleColor,
                    }">
                    {{ disclaimer.contentTitle }}
                </h4>

                <!-- eslint-disable vue/no-v-html -->
                <p v-html="disclaimer.content"></p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ViewProductQuery } from '~/graphql';

type Product = Extract<ViewProductQuery['product'], { __typename: 'ConfigurableProduct' | 'SimpleProduct' }>;
type ProductDisclaimer = Product['disclaimers'][0];

const properties = defineProps<{
    disclaimer: ProductDisclaimer
}>();

const backgroundColor = computed<string>(() => properties.disclaimer.backgroundColor ?? '#ffffff');
const textColor = computed<string>(() => properties.disclaimer.textColor ?? '#000000');
const titleColor = computed<string>(() => properties.disclaimer.titleColor ?? '#000000');
</script>
